"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3858],{

/***/ 56505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



var Ellips = function() {
    return /*#__PURE__*/ _jsx("span", {
        className: "text-muted px-2",
        children: "..."
    });
};
var Pagination = function(param) {
    var data = param.data, onChange = param.onChange;
    if (!data || (data === null || data === void 0 ? void 0 : data.totalPages) < 2) {
        return null;
    }
    var currentIndex = data.currentPage;
    var lastPage = data.totalPages;
    var spaceBetween = 2;
    // const numberOfPages = Math.ceil(paging.count / paging.pageSize);
    var from = Math.max(1, currentIndex - spaceBetween);
    var to = Math.min(lastPage + 1, currentIndex + 1 + spaceBetween);
    var range = lodash_range__WEBPACK_IMPORTED_MODULE_1___default()(from, to);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: "row mt-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "col-lg-4 d-none d-lg-block"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "col-lg-4 col-md-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: "flex-row align-items-center justify-content-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            disabled: data.currentPage === 1,
                            className: "btn btn-secondary btn-pagination  mx-4 px-2",
                            onClick: function() {
                                return onChange(data.currentPage - 1);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                className: "fa fa-chevron-left"
                            })
                        }),
                        from > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                    onClick: function() {
                                        return onChange(1);
                                    },
                                    className: "btn btn-secondary btn-pagination  mx-1 px-2",
                                    children: "1"
                                }),
                                from - 1 > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    className: "fa px-2 text-muted fa-ellipsis"
                                })
                            ]
                        }),
                        range.map(function(v) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                onClick: function() {
                                    return onChange(v);
                                },
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("btn btn-pagination  mx-1 px-2", {
                                    "btn-pagination--active btn-primary": v === currentIndex
                                }, {
                                    "btn-secondary": v !== currentIndex
                                }),
                                children: v
                            }, v);
                        }),
                        to - 1 < lastPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
                            children: [
                                to < lastPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    className: "fa px-2 text-muted fa-ellipsis"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                    onClick: function() {
                                        return onChange(lastPage);
                                    },
                                    className: "btn btn-secondary btn-pagination  mx-1 px-2",
                                    children: lastPage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            disabled: data.currentPage === lastPage,
                            className: "btn btn-secondary btn-pagination  mx-4 px-2",
                            onClick: function() {
                                return onChange(data.currentPage + 1);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                className: "fa fa-chevron-right fs-xs"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "col-4"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 96654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _forms_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41280);
/* harmony import */ var _forms_Dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22866);




var dropdownIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("i", {
    className: "fa fal fa-chevron-down"
});
var buttonClass = "hover-bg-light300";
var EllipsisDropdown = function(param) {
    var children = param.children, _ellipsisIcon = param.ellipsisIcon, ellipsisIcon = _ellipsisIcon === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M12 4C11.175 4 10.5 4.675 10.5 5.5C10.5 6.325 11.175 7 12 7C12.825 7 13.5 6.325 13.5 5.5C13.5 4.675 12.825 4 12 4ZM12 17C11.175 17 10.5 17.675 10.5 18.5C10.5 19.325 11.175 20 12 20C12.825 20 13.5 19.325 13.5 18.5C13.5 17.675 12.825 17 12 17ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z",
            fill: "#1D1D1F"
        })
    }) : _ellipsisIcon, setShow = param.setShow, controlledShow = param.show, style = param.style;
    // State to manage the show state internally if setShow is not provided
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), internalShow = ref[0], setInternalShow = ref[1];
    // Determine if we are using controlled or internal state
    var isControlled = setShow !== undefined;
    var show = isControlled ? controlledShow : internalShow;
    var handleSetShow = function(value) {
        if (isControlled) {
            setShow === null || setShow === void 0 ? void 0 : setShow(value);
        } else {
            setInternalShow(value);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_forms_Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            position: "right",
            dropdownClassName: "ms-4",
            show: show,
            setShow: handleSetShow,
            dropdownContent: children,
            icon: dropdownIcon,
            style: style,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_forms_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                className: buttonClass,
                size: "extra-small",
                onClick: function(e) {
                    e === null || e === void 0 ? void 0 : e.stopPropagation();
                    handleSetShow(!show);
                },
                theme: "text",
                icon: true,
                children: ellipsisIcon
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EllipsisDropdown);


/***/ }),

/***/ 14245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var components_base_forms_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4386);
/* harmony import */ var components_base_forms_Dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22866);
/* harmony import */ var _Calendar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2042);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var common_utils_forms_safeEventParseValue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95894);
/* harmony import */ var project_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71113);











var DateRangePicker = function(_param) {
    var _format = _param.format, format = _format === void 0 ? "DD/MM/YYYY" : _format, inputProps = _param.inputProps, onActiveStartDateChange = _param.onActiveStartDateChange, placeholder = _param.placeholder, calendarProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "format",
        "inputProps",
        "onActiveStartDateChange",
        "placeholder"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showCalendar = ref[0], setShowCalendar = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), inputValue = ref1[0], setInputValue = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), focused = ref2[0], setFocused = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(calendarProps.value && calendarProps.value[0] ? new Date(calendarProps.value[0]) : undefined), activeStartDate = ref3[0], setActiveStartDate = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!focused && calendarProps.value) {
            var newValue = Array.isArray(calendarProps.value) ? "".concat(dayjs__WEBPACK_IMPORTED_MODULE_5___default()(calendarProps.value[0]).format(format), " - ").concat(dayjs__WEBPACK_IMPORTED_MODULE_5___default()(calendarProps.value[1]).format(format)) : "";
            if (newValue !== inputValue) {
                setInputValue(newValue);
            }
        }
    }, [
        calendarProps.value,
        focused
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (calendarProps.value && calendarProps.value[0]) {
            var newStartDate = new Date(calendarProps.value[0]);
            if (newStartDate !== activeStartDate) {
                setActiveStartDate(newStartDate);
                if (onActiveStartDateChange) {
                    onActiveStartDateChange(newStartDate);
                }
            }
        } else if (!calendarProps.value) {
            setInputValue("");
            setActiveStartDate(null);
        }
    }, [
        calendarProps.value
    ]);
    console.log(calendarProps);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        style: {
            width: 220
        },
        className: "d-flex align-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "flex-1",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_forms_Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                show: showCalendar,
                setShow: setShowCalendar,
                dropdownClassName: "px-0 py-0 mt-0",
                dropdownContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_Calendar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    selectRange: true,
                    showDoubleView: true,
                    activeStartDate: activeStartDate,
                    onActiveStartDateChange: function(param) {
                        var activeStartDate = param.activeStartDate;
                        setActiveStartDate(activeStartDate);
                    }
                }, calendarProps), {
                    onChange: function(v) {
                        if (!v) {
                            calendarProps.onChange(null);
                        } else {
                            calendarProps.onChange([
                                v[0].toISOString(),
                                v[1].toISOString(), 
                            ]);
                        }
                        if (v && v[0] && v[0] !== activeStartDate) {
                            setActiveStartDate(new Date(v[0]));
                            if (onActiveStartDateChange) {
                                onActiveStartDateChange(new Date(v[0]));
                            }
                        }
                    }
                })),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_forms_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    onChange: function(e) {
                        var str = (0,common_utils_forms_safeEventParseValue__WEBPACK_IMPORTED_MODULE_10__/* .safeParseEventValue */ .Q)(e);
                        setInputValue(str);
                        var dates = str.split(" - ").map(function(date) {
                            return dayjs__WEBPACK_IMPORTED_MODULE_5___default()(date, format);
                        });
                        if (dates.length === 2 && dates[0].isValid() && dates[1].isValid()) {
                            calendarProps.onChange([
                                dates[0].toISOString(),
                                dates[1].toISOString(), 
                            ]);
                        }
                    },
                    placeholder: placeholder,
                    onFocus: function() {
                        setFocused(true);
                        setShowCalendar(true);
                    },
                    onBlur: function() {
                        setFocused(false);
                    },
                    value: inputValue,
                    onIconRightClick: calendarProps.value ? function() {
                        calendarProps.onChange(null);
                    } : undefined,
                    iconRight: calendarProps.value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                            className: "fa fa-times-circle fs-lg"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(project_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        name: "calendar"
                    })
                }, inputProps || {}))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DateRangePicker);


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ project_SubscriptionTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./common/types/responses.ts
var responses = __webpack_require__(7061);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./common/services/useSubscription.ts + 2 modules
var useSubscription = __webpack_require__(64357);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./common/service.ts + 7 modules
var service = __webpack_require__(24125);
;// CONCATENATED MODULE: ./common/services/useStat.ts



var statService = service/* service.enhanceEndpoints */.Xn.enhanceEndpoints({
    addTagTypes: [
        "Stat"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            getStats: builder.query({
                providesTags: [
                    {
                        id: "LIST",
                        type: "Stat"
                    }
                ],
                query: function() {
                    return {
                        url: "partners/statistics"
                    };
                }
            })
        };
    }
});
function getStats(store, data, options) {
    return _getStats.apply(this, arguments);
}
function _getStats() {
    _getStats = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(statService.endpoints.getStats.initiate(data, options))
            ];
        });
    });
    return _getStats.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useGetStatsQuery = statService /* Usage examples:
const { data, isLoading } = useGetStatsQuery({ id: 2 }, {}) //get hook
const [createStats, { isLoading, data, isSuccess }] = useCreateStatsMutation() //create hook
statService.endpoints.getStats.select({id: 2})(store.getState()) //access data from any function
*/ .useGetStatsQuery;

// EXTERNAL MODULE: ./components/base/Badge.tsx
var Badge = __webpack_require__(84376);
;// CONCATENATED MODULE: ./components/project/Stats.tsx





var Stats = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = useGetStatsQuery({}), data = ref11.data, isLoading = ref11.isLoading;
    var fallback = isLoading ? "" : "0";
    var calculatePercentageChange = function(current, previous) {
        if (previous === 0 && current !== 0) return current * 100;
        if (previous !== 0 && current === 0) return current * -100;
        if (previous === 0) return 0;
        return (current - previous) / previous * 100;
    };
    var items = [
        {
            description: "API ".concat((data === null || data === void 0 ? void 0 : (ref = data.active_subscriptions) === null || ref === void 0 ? void 0 : ref.api) || fallback, " | Campaign ").concat((data === null || data === void 0 ? void 0 : (ref1 = data.active_subscriptions) === null || ref1 === void 0 ? void 0 : ref1.campaign) || fallback),
            percentage_change: null,
            title: "Active Subscriptions",
            value: (data === null || data === void 0 ? void 0 : (ref2 = data.active_subscriptions) === null || ref2 === void 0 ? void 0 : ref2.total) || fallback
        },
        {
            description: "Last month ".concat((data === null || data === void 0 ? void 0 : (ref3 = data.sign_ups) === null || ref3 === void 0 ? void 0 : ref3.last_month) || fallback),
            percentage_change: calculatePercentageChange((data === null || data === void 0 ? void 0 : (ref4 = data.sign_ups) === null || ref4 === void 0 ? void 0 : ref4.this_month) || 0, (data === null || data === void 0 ? void 0 : (ref5 = data.sign_ups) === null || ref5 === void 0 ? void 0 : ref5.last_month) || 0),
            title: "Signups this month",
            value: (data === null || data === void 0 ? void 0 : (ref6 = data.sign_ups) === null || ref6 === void 0 ? void 0 : ref6.this_month) || fallback
        },
        {
            description: "Yesterday ".concat((data === null || data === void 0 ? void 0 : (ref7 = data.sign_ups) === null || ref7 === void 0 ? void 0 : ref7.yesterday) || fallback),
            percentage_change: calculatePercentageChange((data === null || data === void 0 ? void 0 : (ref8 = data.sign_ups) === null || ref8 === void 0 ? void 0 : ref8.today) || 0, (data === null || data === void 0 ? void 0 : (ref9 = data.sign_ups) === null || ref9 === void 0 ? void 0 : ref9.yesterday) || 0),
            title: "Signups today",
            value: (data === null || data === void 0 ? void 0 : (ref10 = data.sign_ups) === null || ref10 === void 0 ? void 0 : ref10.today) || fallback
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: classnames_default()({
            "opacity-50": isLoading
        }, "d-flex flex-column flex-md-row gap-4"),
        children: items.map(function(v, i) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "flex-1 px-2 py-4 bg-white d-flex align-items-center px-4 rounded shadow-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex-1 flex-column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                className: "d-flex mt-2 fw-semibold gap-2 align-items-center",
                                children: v.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "d-flex align-items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h5", {
                                        className: "text-muted mb-0 fw-semibold",
                                        children: v.description
                                    }),
                                    v.percentage_change !== null && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Badge/* default */.Z, {
                                        className: "ms-4",
                                        theme: !v.percentage_change ? "info" : v.percentage_change > 0 ? "success" : "danger",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                className: "fa fa-line-chart me-1"
                                            }),
                                            " ",
                                            v.percentage_change ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                                children: [
                                                    v.percentage_change > 0 && "+",
                                                    v.percentage_change.toFixed(0),
                                                    "%"
                                                ]
                                            }) : "no change"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h1", {
                        className: "mb-0",
                        style: {
                            fontSize: 32
                        },
                        children: v.value
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ var project_Stats = (Stats);

// EXTERNAL MODULE: ./project/Icon.tsx
var Icon = __webpack_require__(71113);
// EXTERNAL MODULE: ./components/project/PlanName.tsx + 1 modules
var PlanName = __webpack_require__(7977);
// EXTERNAL MODULE: ./components/project/KYCStatus.tsx
var KYCStatus = __webpack_require__(5109);
// EXTERNAL MODULE: ./common/store.ts + 3 modules
var store = __webpack_require__(71185);
// EXTERNAL MODULE: ./components/base/Loader.tsx
var Loader = __webpack_require__(1986);
// EXTERNAL MODULE: ./components/Pagination.tsx
var Pagination = __webpack_require__(56505);
// EXTERNAL MODULE: ./components/base/forms/Button.tsx
var Button = __webpack_require__(41280);
// EXTERNAL MODULE: ./components/base/Messages.tsx + 1 modules
var Messages = __webpack_require__(56884);
// EXTERNAL MODULE: ./node_modules/material-ui-chip-input/lib/ChipInput.js
var ChipInput = __webpack_require__(41492);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 10 modules
var Chip = __webpack_require__(11102);
// EXTERNAL MODULE: ./common/utils/string/enumeration.ts
var enumeration = __webpack_require__(70752);
// EXTERNAL MODULE: ./node_modules/lodash-es/flatten.js
var flatten = __webpack_require__(62543);
// EXTERNAL MODULE: ./common/utils/forms/safeEventParseValue.ts
var safeEventParseValue = __webpack_require__(95894);
// EXTERNAL MODULE: ./common/hooks/useSearchThrottle.ts + 1 modules
var useSearchThrottle = __webpack_require__(17737);
;// CONCATENATED MODULE: ./components/tables/FilterInput.tsx









var FilterInput = function(param) {
    var disabled = param.disabled, filters = param.filters, onChange = param.onChange, onClear = param.onClear, placeholder = param.placeholder, setPage = param.setPage, value = param.value;
    var ref = (0,useSearchThrottle/* default */.Z)(value || "", onChange), searchInput = ref.searchInput, setSearchInput = ref.setSearchInput;
    var onChangeText = function(e) {
        setSearchInput((0,safeEventParseValue/* safeParseEventValue */.Q)(e));
    };
    var filterValue = (0,flatten/* default */.Z)(filters.map(function(v) {
        return v.value.map(function(item) {
            return {
                onDelete: function() {
                    setPage === null || setPage === void 0 ? void 0 : setPage(1);
                    v.onChange(v.value.filter(function(value) {
                        return value !== item;
                    }));
                },
                renderOption: v.getLabel || v.renderOption,
                value: item
            };
        });
    }));
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: classnames_default()("position-relative input-container", {
            "input-container--with-right-icon": !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.length)
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ChipInput/* default */.ZP, {
                disabled: disabled,
                fullWidth: true,
                placeholder: placeholder,
                disableUnderline: true,
                blurBehavior: "ignore",
                onInput: onChangeText,
                newChipKeys: [],
                newChipKeyCodes: [],
                inputValue: searchInput,
                value: filterValue,
                onDelete: function(_, index) {
                    var ref, ref1;
                    filterValue === null || filterValue === void 0 ? void 0 : (ref = filterValue[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.onDelete) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
                },
                classes: {
                    chip: "chip",
                    root: "mui-root"
                },
                chipRenderer: function(param, key) {
                    var className = param.className, handleClick = param.handleClick, value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Chip/* default */.Z, {
                        className: "".concat(className, " badge badge-secondary"),
                        onClick: handleClick,
                        onDelete: value.onDelete,
                        label: value.renderOption ? value.renderOption(value.value) : enumeration/* enumeration.get */.J.get(value.value),
                        deleteIcon: disabled ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {}) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "chip-icon fa fa-times"
                        })
                    }, key);
                }
            }),
            !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue.length) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                onClick: function() {
                    if (onClear) {
                        onClear();
                        return;
                    }
                    filters.map(function(v) {
                        setPage === null || setPage === void 0 ? void 0 : setPage(1);
                        v.onChange([]);
                    });
                },
                className: "cursor-pointer input-icon icon-right",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                    className: "fa fa-times-circle"
                })
            })
        ]
    });
};
/* harmony default export */ var tables_FilterInput = (FilterInput);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/base/forms/Dropdown.tsx + 3 modules
var Dropdown = __webpack_require__(22866);
// EXTERNAL MODULE: ./components/base/SelectIcon.tsx
var SelectIcon = __webpack_require__(98908);
;// CONCATENATED MODULE: ./components/base/TextDropdown.tsx






var TextDropdown = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Dropdown/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            onClick: function() {
                return props.setShow(!props.show);
            },
            className: "flex-row cursor-pointer h-100 d-flex align-items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "me-2 fw-semibold user-select-none",
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectIcon/* default */.Z, {})
            ]
        })
    }));
};
/* harmony default export */ var base_TextDropdown = (TextDropdown);

// EXTERNAL MODULE: ./components/base/forms/DropdownItem.tsx
var DropdownItem = __webpack_require__(74274);
;// CONCATENATED MODULE: ./components/base/SelectDropdown.tsx





var SelectDropdown = function(param) {
    var onChange = param.onChange, options = param.options, renderOption = param.renderOption, title = param.title, value = param.value;
    var ref = (0,compat_module.useState)(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(base_TextDropdown, {
        show: show,
        setShow: setShow,
        dropdownContent: options === null || options === void 0 ? void 0 : options.map(function(v, i) {
            var selected = value === null || value === void 0 ? void 0 : value.includes(v);
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownItem/* default */.Z, {
                onClick: function() {
                    if (selected) {
                        onChange((value || []).filter(function(item) {
                            return v !== item;
                        }));
                    } else {
                        onChange((value || []).concat([
                            v
                        ]));
                    }
                    setShow(false);
                },
                selected: selected,
                children: renderOption ? renderOption(v) : enumeration/* enumeration.get */.J.get(v)
            }, i);
        }),
        children: title
    });
};
/* harmony default export */ var base_SelectDropdown = (SelectDropdown);

;// CONCATENATED MODULE: ./components/tables/TableFilter.tsx



var TableFilter = function(param) {
    var children = param.children, customFilters = param.customFilters, filters = param.filters, hideInput = param.hideInput, onChange = param.onChange, placeholder = param.placeholder, setPage = param.setPage, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "py-4 px-1 my-1 align-items-center d-flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "body-secondary",
                children: "Filter"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "ps-8 align-items-center d-flex",
                children: [
                    filters.map(function(v) {
                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "me-4",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(base_SelectDropdown, {
                                options: v.options,
                                renderOption: v.renderOption,
                                title: v.label,
                                value: v.value,
                                onChange: function(newValue) {
                                    setPage === null || setPage === void 0 ? void 0 : setPage(1);
                                    v.onChange(newValue);
                                }
                            })
                        }, v.label);
                    }),
                    customFilters
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "flex-fill",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "w-100",
                    style: {
                        maxWidth: 700
                    },
                    children: !hideInput && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tables_FilterInput, {
                        placeholder: placeholder || "Search...",
                        filters: filters,
                        setPage: setPage,
                        value: value,
                        onChange: function(v) {
                            setPage === null || setPage === void 0 ? void 0 : setPage(1);
                            onChange(v);
                        }
                    })
                })
            }),
            children
        ]
    });
};
/* harmony default export */ var tables_TableFilter = (TableFilter);

// EXTERNAL MODULE: ./common/utils/date/dateAndTime.ts
var dateAndTime = __webpack_require__(2116);
// EXTERNAL MODULE: ./common/utils/urls/param.ts + 1 modules
var urls_param = __webpack_require__(57384);
// EXTERNAL MODULE: ./components/CancelSubscription.tsx + 1 modules
var CancelSubscription = __webpack_require__(78111);
// EXTERNAL MODULE: ./components/base/EllipsisDropdown.tsx
var EllipsisDropdown = __webpack_require__(96654);
// EXTERNAL MODULE: ./common/services/useUser.ts
var useUser = __webpack_require__(99195);
// EXTERNAL MODULE: ./components/tables/NoResultsMessage.tsx
var NoResultsMessage = __webpack_require__(23011);
// EXTERNAL MODULE: ./components/tables/ContentContainer.tsx
var ContentContainer = __webpack_require__(58086);
// EXTERNAL MODULE: ./components/base/forms/date/DateRangePicker.tsx
var DateRangePicker = __webpack_require__(14245);
// EXTERNAL MODULE: ./common/utils/track-subscription.ts
var track_subscription = __webpack_require__(22414);
// EXTERNAL MODULE: ./common/services/useGroup.ts
var useGroup = __webpack_require__(64344);
// EXTERNAL MODULE: ./components/base/forms/Checkbox.tsx
var Checkbox = __webpack_require__(17550);
// EXTERNAL MODULE: ./common/services/useTeamMember.ts
var useTeamMember = __webpack_require__(76527);
// EXTERNAL MODULE: ./common/utils/string/camelCase.ts
var camelCase = __webpack_require__(73255);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/base/Toast.tsx
var Toast = __webpack_require__(12198);
// EXTERNAL MODULE: ./components/base/ModalDefault.tsx
var ModalDefault = __webpack_require__(17977);
// EXTERNAL MODULE: ./components/project/GroupSelect.tsx
var GroupSelect = __webpack_require__(50152);
// EXTERNAL MODULE: ./common/services/useAssignCompanyGroup.ts
var useAssignCompanyGroup = __webpack_require__(45648);
;// CONCATENATED MODULE: ./components/ReassignCustomer.tsx













var ReassignCustomer = function(param) {
    var from = param.from, isOpen = param.isOpen, onComplete = param.onComplete, selectedCustomers = param.selectedCustomers, setIsOpen = param.setIsOpen;
    var ref = (0,compat_module.useState)(1), step = ref[0], setStep = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,compat_module.useState)(), reassignTo = ref1[0], setReassignTo = ref1[1];
    var ref2 = (0,useGroup/* useGetGroupsQuery */.Ky)({}), groups = ref2.data;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useAssignCompanyGroup/* useCreateAssignCompanyGroupsMutation */.Vh)({}), 2), createAssignment = ref3[0], ref4 = ref3[1], error = ref4.error, isLoading = ref4.isLoading;
    var handleAssign = function() {
        if (!reassignTo) return;
        createAssignment({
            subscriptions: selectedCustomers,
            to: reassignTo
        }).then(function(res) {
            if (!res.error) {
                setIsOpen(false);
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                (0,Toast/* toast */.Am)("Success", "Reassigned companies");
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ModalDefault/* default */.Z, {
        title: "Reassign Customers",
        preventDismiss: isLoading,
        isOpen: isOpen,
        onDismiss: function() {
            return setIsOpen(false);
        },
        toggle: function() {
            return setIsOpen(false);
        },
        size: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Messages/* ErrorMessage */.Bc, {
                children: error
            }),
            step === 2 ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                        className: "fw-semibold mb-6",
                        children: "Step 2: Confirm Group Assignment"
                    }),
                    !!from && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupSelect/* default */.Z, {
                        label: "Current Assigned Group",
                        value: parseInt(router.query.id),
                        disabled: true,
                        onChange: function() {},
                        className: "mb-5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupSelect/* default */.Z, {
                        label: "Assign to Group",
                        value: reassignTo,
                        excludeGroups: [
                            parseInt("".concat(router.query.id))
                        ],
                        onChange: function(v) {
                            return setReassignTo(v.value);
                        },
                        defaultValue: router.query.id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "bg-light300 rounded p-4 text-muted fs-xs mt-24",
                        children: "Add teams members using the search field above. Please add any relevant team members via the invite functionality on the ‘Members’ tab."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "text-end mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                                style: {
                                    width: 160
                                },
                                onClick: function() {
                                    setIsOpen(false);
                                },
                                className: "me-2",
                                theme: "secondary",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                                style: {
                                    width: 160
                                },
                                className: "me-2",
                                disabled: isLoading || !reassignTo,
                                onClick: handleAssign,
                                children: "Confirm & Assign"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                        className: "fw-semibold mb-0",
                        children: "Step 1: Confirm Customers to reassign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        style: {
                            maxHeight: 300
                        },
                        className: "d-flex overflow-y-auto flex-column mt-8 pe-2",
                        children: selectedCustomers.map(function(customer) {
                            var ref, ref1;
                            var customerGroup = (ref = customer.groups) === null || ref === void 0 ? void 0 : ref[0];
                            var group = !!customerGroup && (groups === null || groups === void 0 ? void 0 : (ref1 = groups.results) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
                                return v.id === (customerGroup === null || customerGroup === void 0 ? void 0 : customerGroup.group_id);
                            }));
                            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        className: "d-flex flex-row justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                className: "d-flex gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Checkbox/* default */.Z, {
                                                        id: customer.id.toString(),
                                                        checked: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                        className: "d-flex flex-column",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                                className: "fw-semibold",
                                                                children: customer.company_name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                                children: customer.email_address
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(KYCStatus/* default */.Z, {
                                                subscription: customer
                                            })
                                        ]
                                    }, customer.id),
                                    !from && !!group && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                        className: "fs-xs mt-2",
                                        children: [
                                            "This customer will be removed from group",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                children: group.name
                                            })
                                        ]
                                    }),
                                    !from && !group && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "fs-xs text-muted mt-2",
                                        children: "This customer is not currently a member of a group"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("hr", {
                                        className: "my-3"
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "text-end mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                                onClick: function() {
                                    setIsOpen(false);
                                },
                                style: {
                                    width: 125
                                },
                                disabled: isLoading,
                                className: "me-2",
                                theme: "secondary",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                                style: {
                                    width: 125
                                },
                                disabled: isLoading,
                                className: "me-2",
                                onClick: function() {
                                    return setStep(2);
                                },
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ReassignCustomer = (ReassignCustomer);

// EXTERNAL MODULE: ./components/project/CreateEditGroup.tsx + 1 modules
var CreateEditGroup = __webpack_require__(63278);
;// CONCATENATED MODULE: ./components/project/SubscriptionTable.tsx




































var downloadCSV = function(csvString, filename) {
    var blob = new Blob([
        csvString
    ], {
        type: "text/csv"
    });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.click();
    window.URL.revokeObjectURL(url);
};
var SubscriptionTable = function(param) {
    var cta = param.cta, _filter = param.filter, filter = _filter === void 0 ? {} : _filter, group = param.group, hideFilter = param.hideFilter, onSelectChange = param.onSelectChange;
    var ref, ref1, ref2, ref3;
    var params = (0,urls_param/* fromParam */.m)();
    var ref4 = (0,compat_module.useState)(params.status ? params.status.split(",") : []), status = ref4[0], setStatus = ref4[1];
    var ref5 = (0,compat_module.useState)(params.groups ? (ref = params.groups.split(",")) === null || ref === void 0 ? void 0 : ref.map(function(v) {
        if (isNaN(parseInt(v))) {
            return v;
        }
        return parseInt(v);
    }) : []), groups = ref5[0], setGroups = ref5[1];
    var ref6 = (0,compat_module.useState)(false), showSelection = ref6[0], setShowSelection = ref6[1];
    var ref7 = (0,compat_module.useState)(params.members ? (ref1 = params.members.split(",")) === null || ref1 === void 0 ? void 0 : ref1.map(parseInt) : []), members = ref7[0], setMembers = ref7[1];
    var ref8 = (0,compat_module.useState)(), selection = ref8[0], setSelection = ref8[1];
    (0,compat_module.useEffect)(function() {
        setSelection([]);
    }, [
        showSelection
    ]);
    var ref9 = (0,compat_module.useState)(false), showEditGroup = ref9[0], setShowEditGroup = ref9[1];
    var ref10 = (0,useUser/* useUser */.aF)({}), user = ref10.data;
    var ref11 = (0,compat_module.useState)(params.q || ""), searchInput = ref11[0], setSearchInput = ref11[1];
    var ref12 = (0,compat_module.useState)(params.date_from || undefined), dateFrom = ref12[0], setDateFrom = ref12[1];
    var ref13 = (0,compat_module.useState)(params.date_to || undefined), dateTo = ref13[0], setDateTo = ref13[1];
    var ref14 = (0,compat_module.useState)(1), page = ref14[0], setPage = ref14[1];
    var canEdit = (0,useUser/* usePermission */.gI)("WRITE");
    var router = (0,next_router.useRouter)();
    var ref15 = (0,compat_module.useState)(), activeCustomerId = ref15[0], setActiveCustomerId = ref15[1];
    var ref16 = (0,compat_module.useState)(), activeSubscription = ref16[0], setActiveSubscription = ref16[1];
    var ref17 = (0,compat_module.useState)(), activeSubscriptionId = ref17[0], setActiveSubscriptionId = ref17[1];
    var ref18 = (0,compat_module.useState)(false), showCancel = ref18[0], setShowCancel = ref18[1];
    var ref19 = (0,useGroup/* useGetGroupsQuery */.Ky)({}), allGroups = ref19.data;
    var ref20 = (0,useTeamMember/* useGetTeamMembersQuery */.LL)({}), allMembers = ref20.data;
    var ref21 = (0,compat_module.useState)(false), isExporting = ref21[0], setIsExporting = ref21[1];
    var ref22 = (0,compat_module.useState)(false), showReassignment = ref22[0], setShowReassignment = ref22[1];
    var ref23 = (0,useGroup/* useGetGroupQuery */.EF)({
        id: group
    }, {
        skip: !group
    }), groupDetail = ref23.data;
    var groupsAndMemberGroups = (0,compat_module.useMemo)(function() {
        var ref, ref1;
        if (!(members === null || members === void 0 ? void 0 : members.length) || !(allGroups === null || allGroups === void 0 ? void 0 : (ref = allGroups.results) === null || ref === void 0 ? void 0 : ref.length)) {
            return groups;
        }
        var addedGroups = allGroups === null || allGroups === void 0 ? void 0 : (ref1 = allGroups.results) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
            var ref;
            if (groups.includes(v.id)) {
                return null;
            }
            if ((ref = v.users) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                return members.includes(v.user_id);
            })) {
                return true;
            }
        }).map(function(v) {
            return v.id;
        });
        return groups.concat(addedGroups);
    }, [
        allGroups,
        members,
        groups
    ]);
    var filters = (0,compat_module.useMemo)(function() {
        var ref, ref1;
        var filteredMembers = allMembers === null || allMembers === void 0 ? void 0 : (ref = allMembers.results) === null || ref === void 0 ? void 0 : ref.filter(function(member) {
            var ref;
            return allGroups === null || allGroups === void 0 ? void 0 : (ref = allGroups.results) === null || ref === void 0 ? void 0 : ref.find(function(group) {
                var ref;
                return (ref = group.users) === null || ref === void 0 ? void 0 : ref.find(function(groupUser) {
                    return groupUser.user_id === member.id;
                });
            });
        });
        return [
            {
                getLabel: function(option) {
                    var ref;
                    var member = allMembers === null || allMembers === void 0 ? void 0 : (ref = allMembers.results) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                        return v.id === option;
                    });
                    return "".concat(member === null || member === void 0 ? void 0 : member.first_name, " ").concat(member === null || member === void 0 ? void 0 : member.last_name);
                },
                getSearch: function(option) {
                    var ref;
                    var member = allMembers === null || allMembers === void 0 ? void 0 : (ref = allMembers.results) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                        return v.id === option;
                    });
                    return "".concat(member === null || member === void 0 ? void 0 : member.first_name, " ").concat(member === null || member === void 0 ? void 0 : member.last_name, " ").concat(member === null || member === void 0 ? void 0 : member.email);
                },
                label: "Members",
                onChange: (filteredMembers === null || filteredMembers === void 0 ? void 0 : filteredMembers.length) ? setMembers : function() {},
                options: (filteredMembers === null || filteredMembers === void 0 ? void 0 : filteredMembers.length) ? filteredMembers.map(function(v) {
                    return v.id;
                }) : [
                    null
                ],
                renderOption: function(option) {
                    var ref;
                    if (!(filteredMembers === null || filteredMembers === void 0 ? void 0 : filteredMembers.length)) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "d-flex text-center text-muted flex-column gap-0",
                            children: [
                                "You have no groups that contain members.",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                "Create them in the Team page."
                            ]
                        });
                    }
                    var member = allMembers === null || allMembers === void 0 ? void 0 : (ref = allMembers.results) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                        return v.id === option;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "d-flex mb-2 flex-column gap-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "fw-semibold",
                                children: [
                                    member === null || member === void 0 ? void 0 : member.first_name,
                                    " ",
                                    member === null || member === void 0 ? void 0 : member.last_name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "fs-sm text-muted lh-1",
                                children: member === null || member === void 0 ? void 0 : member.email
                            })
                        ]
                    });
                },
                value: members
            },
            {
                label: "Groups",
                onChange: function(v) {
                    if (v[v.length - 1] === "none") {
                        setGroups([
                            "none"
                        ]);
                        setMembers([]);
                    } else {
                        setGroups(v.filter(function(v) {
                            return v !== "none";
                        }));
                    }
                },
                options: [
                    "none"
                ].concat(allGroups === null || allGroups === void 0 ? void 0 : (ref1 = allGroups.results) === null || ref1 === void 0 ? void 0 : ref1.map(function(v) {
                    return v.id;
                })),
                renderOption: function(option) {
                    var ref, ref1, ref2;
                    if (!(allGroups === null || allGroups === void 0 ? void 0 : (ref = allGroups.results) === null || ref === void 0 ? void 0 : ref.length)) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "d-flex text-muted flex-column gap-0",
                            children: [
                                "You have no groups.",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                "Create them in the Team page."
                            ]
                        });
                    }
                    return typeof option === "string" ? (0,camelCase/* camelCase */.e)(option) : (ref2 = allGroups === null || allGroups === void 0 ? void 0 : (ref1 = allGroups.results) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
                        return v.id === option;
                    })) === null || ref2 === void 0 ? void 0 : ref2.name;
                },
                value: groups
            },
            {
                label: "Status",
                onChange: setStatus,
                options: responses/* CustomerStatuses */.Pz,
                value: status
            }, 
        ].filter(function(v) {
            return !!v;
        });
    }, [
        status,
        groups,
        members,
        allMembers,
        allGroups
    ]);
    var ref24 = (0,useSubscription/* useGetSubscriptionsQuery */.Tb)((0,_object_spread/* default */.Z)({
        date_from: dateFrom,
        date_to: dateTo,
        groups: groupsAndMemberGroups,
        page: page,
        page_size: 20,
        q: searchInput,
        status: status
    }, filter)), data = ref24.data, error = ref24.error, isFetching = ref24.isFetching, isLoading = ref24.isLoading;
    (0,compat_module.useEffect)(function() {
        router.replace("".concat(document.location.pathname, "?").concat((0,urls_param/* toParam */.i)({
            date_from: dateFrom,
            date_to: dateTo,
            groups: groups.join(","),
            members: members.join(","),
            page: page,
            q: searchInput,
            status: status.join(",")
        })));
    //eslint-disable-next-line
    }, [
        searchInput,
        dateFrom,
        dateTo,
        page,
        members,
        groups,
        status
    ]);
    var handleExport = function() {
        setIsExporting(true);
        (0,useSubscription/* getSubscriptions */.tJ)((0,store/* getStore */.b)(), {
            date_from: dateFrom,
            date_to: dateTo,
            export: true,
            page: page,
            page_size: (data === null || data === void 0 ? void 0 : data.count) || 20,
            q: searchInput,
            status: status
        }).then(function(res) {
            setIsExporting(false);
            if (!res.data) return;
            downloadCSV(res.data, "customers_export_".concat(dayjs_min_default()().format("YYYY-MM-DD"), ".csv"));
        }).catch(function(error) {
            setIsExporting(false);
            console.error("Export error:", error);
        });
    };
    return isLoading && !data ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Loader/* default */.Z, {})
    }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            hideFilter !== true && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "d-none d-xl-block",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(project_Stats, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "d-flex align-items-center justify-content-between gap-4",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "flex-1",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tables_TableFilter, {
                                placeholder: "Search subscriptions...",
                                customFilters: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "me-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DateRangePicker/* default */.Z, {
                                        selectRange: true,
                                        showDoubleView: true,
                                        placeholder: "Filter by date",
                                        showNeighboringMonth: false,
                                        onChange: function(v) {
                                            // @ts-ignore
                                            if ((v === null || v === void 0 ? void 0 : v[0]) && (v === null || v === void 0 ? void 0 : v[1])) {
                                                // @ts-ignore
                                                setDateFrom(dayjs_min_default()(v[0]).format("YYYY-MM-DD"));
                                                // @ts-ignore
                                                setDateTo(dayjs_min_default()(v[1]).format("YYYY-MM-DD"));
                                            } else {
                                                setDateFrom(undefined);
                                                setDateTo(undefined);
                                            }
                                        },
                                        value: dateFrom && dateTo ? [
                                            dayjs_min_default()(dateFrom, "YYYY-MM-DD").toISOString(),
                                            dayjs_min_default()(dateTo, "YYYY-MM-DD").toISOString(), 
                                        ] : null
                                    })
                                }),
                                filters: filters,
                                onChange: setSearchInput,
                                value: searchInput
                            })
                        })
                    })
                ]
            }, "filter"),
            !showSelection && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "d-flex justify-content-end mb-5 gap-4",
                children: [
                    canEdit && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                        href: "/customers/create".concat(group ? "?groups=".concat(group) : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "d-flex gap-2 align-items-center",
                                children: [
                                    "Add Customer",
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                        fill: "white",
                                        name: "add-user"
                                    })
                                ]
                            })
                        })
                    }),
                    !!(data === null || data === void 0 ? void 0 : data.results.length) && !!setShowSelection && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                        theme: "tertiary",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            onClick: function() {
                                return setShowSelection(true);
                            },
                            className: "d-flex gap-2 align-items-center",
                            children: [
                                "Manage Customers",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                    fill: "white",
                                    name: "user-settings"
                                })
                            ]
                        })
                    }),
                    group ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                                theme: "secondary",
                                onClick: function() {
                                    return setShowEditGroup(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "d-flex gap-2 align-items-center",
                                    children: [
                                        "Edit Group",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                            name: "edit"
                                        })
                                    ]
                                })
                            }),
                            !!groupDetail && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalDefault/* default */.Z, {
                                isOpen: showEditGroup,
                                title: "Edit Group",
                                onDismiss: function() {
                                    return setShowEditGroup(false);
                                },
                                toggle: function() {
                                    return setShowEditGroup(!showEditGroup);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CreateEditGroup/* default */.Z, {
                                    onComplete: function() {
                                        setShowEditGroup(false);
                                    },
                                    group: groupDetail
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                        theme: "secondary",
                        onClick: handleExport,
                        disabled: isExporting,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "d-flex gap-2 align-items-center",
                            children: [
                                "Export CSV",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                    name: "download"
                                })
                            ]
                        })
                    })
                ]
            }),
            !!showSelection && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "d-flex align-items-center justify-content-end mb-5 gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                children: selection.length
                            }),
                            " selected"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                        style: {
                            width: 140
                        },
                        onClick: function() {
                            setShowSelection(false);
                            setSelection([]);
                        },
                        theme: "secondary",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* default */.ZP, {
                        style: {
                            width: 140
                        },
                        disabled: selection.length === 0,
                        onClick: function() {
                            return setShowReassignment(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "d-flex gap-2 align-items-center",
                            children: [
                                "Reassign",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                    fill: "white",
                                    name: "team"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Messages/* ErrorMessage */.Bc, {
                className: "mb-4",
                children: error
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ContentContainer/* default */.Z, {
                className: "pb-1",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("table", {
                    className: classnames_default()({
                        disabled: isFetching
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("tr", {
                                style: {
                                    verticalAlign: "middle"
                                },
                                children: [
                                    showSelection && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                        className: "text-nowrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Checkbox/* default */.Z, {
                                            id: "select-all",
                                            onChange: function() {
                                                if (data) {
                                                    var ref;
                                                    if ((selection === null || selection === void 0 ? void 0 : selection.length) === (data === null || data === void 0 ? void 0 : (ref = data.results) === null || ref === void 0 ? void 0 : ref.length)) {
                                                        setSelection([]);
                                                        onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange([]);
                                                    } else {
                                                        setSelection(data.results);
                                                        onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(data.results);
                                                    }
                                                }
                                            },
                                            checked: (selection === null || selection === void 0 ? void 0 : selection.length) === (data === null || data === void 0 ? void 0 : (ref2 = data.results) === null || ref2 === void 0 ? void 0 : ref2.length)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                        className: "text-nowrap",
                                        children: "Company"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                        className: "d-md-table-cell d-none text-nowrap",
                                        children: "Subscription"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                        style: {
                                            width: 180
                                        },
                                        className: "d-md-table-cell d-none text-nowrap",
                                        children: "Date"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                        style: {
                                            width: 250
                                        },
                                        className: "d-md-table-cell d-none text-nowrap",
                                        children: "Group"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                        style: {
                                            width: 100
                                        },
                                        className: "text-nowrap",
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                        style: {
                                            width: 50
                                        },
                                        className: "text-nowrap"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NoResultsMessage/* default */.Z, {
                                    data: data
                                }),
                                data === null || data === void 0 ? void 0 : (ref3 = data.results) === null || ref3 === void 0 ? void 0 : ref3.map(function(subscription) {
                                    var ref;
                                    var goSubscription = function() {
                                        router.push("/customers/".concat(encodeURIComponent("".concat(subscription.company_id)), "/subscriptions/").concat(encodeURIComponent(subscription.id)));
                                    };
                                    var goCompany = function() {
                                        router.push("/customers/".concat(encodeURIComponent("".concat(subscription.company_id))));
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("tr", {
                                        style: {
                                            verticalAlign: "middle"
                                        },
                                        children: [
                                            showSelection && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Checkbox/* default */.Z, {
                                                    id: "select-".concat(subscription.id),
                                                    onChange: function() {
                                                        if (selection === null || selection === void 0 ? void 0 : selection.includes(subscription)) {
                                                            setSelection(selection.filter(function(v) {
                                                                return v.id !== subscription.id;
                                                            }));
                                                            onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(selection.filter(function(v) {
                                                                return v.id !== subscription.id;
                                                            }));
                                                        } else {
                                                            setSelection((selection || []).concat([
                                                                subscription
                                                            ]));
                                                            onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange((selection || []).concat([
                                                                subscription
                                                            ]));
                                                        }
                                                    },
                                                    checked: !!(selection === null || selection === void 0 ? void 0 : selection.find(function(v) {
                                                        return v.id === subscription.id;
                                                    }))
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                onClick: goCompany,
                                                className: "d-none fw-bold cursor-pointer d-md-table-cell hover-primary",
                                                children: subscription.company_name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("td", {
                                                className: "d-table-cell d-md-none",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                        onClick: goCompany,
                                                        className: "fw-bold pb-2 hover-primary",
                                                        children: subscription.company_name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                        onClick: goSubscription,
                                                        className: "fw-semibold hover-primary d-block d-md-none",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PlanName/* default */.Z, {
                                                                id: subscription.plan_id
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                                children: subscription.email_address
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                onClick: goSubscription,
                                                className: "d-none hover-primary cursor-pointer hover-target d-md-table-cell",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PlanName/* default */.Z, {
                                                    id: subscription.plan_id
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                className: "d-none d-md-table-cell",
                                                children: (0,dateAndTime/* default */.Z)(subscription.created_at)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                children: subscription === null || subscription === void 0 ? void 0 : (ref = subscription.groups) === null || ref === void 0 ? void 0 : ref.map(function(v) {
                                                    return v.name;
                                                }).join(", ")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(KYCStatus/* default */.Z, {
                                                    subscription: subscription
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                children: cta ? cta(subscription) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(EllipsisDropdown/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownItem/* default */.Z, {
                                                            icon: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "edit"
                                                            }),
                                                            onClick: goSubscription,
                                                            children: "Edit Subscription"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownItem/* default */.Z, {
                                                            icon: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "delete",
                                                                fill: "danger"
                                                            }),
                                                            onClick: function() {
                                                                setActiveCustomerId(subscription.company_id);
                                                                setActiveSubscription(subscription);
                                                                setActiveSubscriptionId(subscription.id);
                                                                setShowCancel(true);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                                className: "text-danger",
                                                                children: "Cancel Subscription"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, subscription.id);
                                })
                            ]
                        })
                    ]
                })
            }),
            !!showSelection && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_ReassignCustomer, {
                from: group,
                isOpen: showReassignment,
                setIsOpen: setShowReassignment,
                selectedCustomers: selection,
                onComplete: function() {
                    setPage(1);
                    setSelection([]);
                    setShowSelection(false);
                }
            }),
            !!activeCustomerId && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CancelSubscription/* default */.Z, {
                isOpen: showCancel,
                setIsOpen: setShowCancel,
                customerId: activeCustomerId,
                id: activeSubscriptionId,
                onCancel: function() {
                    (0,track_subscription/* trackCancelSubscription */.rx)(activeSubscription, user);
                }
            }),
            !!data && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Pagination/* default */.Z, {
                data: data,
                onChange: setPage
            })
        ]
    });
};
/* harmony default export */ var project_SubscriptionTable = (SubscriptionTable);


/***/ }),

/***/ 23011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);

var NoResultsMessage = function(param) {
    var data = param.data;
    var ref;
    //@ts-ignore
    return !(data === null || data === void 0 ? void 0 : (ref = data.results) === null || ref === void 0 ? void 0 : ref.length) && !(data === null || data === void 0 ? void 0 : data.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("tr", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("td", {
            className: "text-center py-3",
            colSpan: 99,
            children: "No results."
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (NoResultsMessage);


/***/ })

}]);